module.exports = __webpack_public_path__ + "img/gh-40370.asm.fa9dc906.jpg";